// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__AXoXI","active":"Switch_active__8r78m"};